export default {
  primaryStyle: {
    fill: '#da0d15',
    cursor: 'pointer',
  },
  secondaryStyle: {
    fill: 'transparent',
    cursor: 'pointer',
  },
  textStyle: {
    fontFamily: '"Joti One", cursive',
    fontSize: 60,
    fill: '#e3e3e3',
    cursor: 'pointer',
  },
};



// WEBPACK FOOTER //
// ./src/components/Button/styles.js